exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._1QFug{background:#fff;color:#333;padding:0}._1aTkE{margin:0 auto;border-top:1px solid #dce0e0;max-width:100%;font-size:1.5em;display:block}._2ksEc{max-width:1080px;margin:0 auto}.rSBRL{display:block}._3Xd68{padding:40px 30px;border-right:1px solid #dce0e0;display:inline-block;float:none}._3Xd68:last-of-type{border-right:1px solid transparent}.XMBLN{float:left;display:table;font-size:33px;height:33px;width:33px;line-height:20px;margin-right:22px}._1GBhB{display:table;text-align:left}._3Y6Jq{color:#484848;font-size:15px;font-weight:700;display:block;margin-bottom:10px;line-height:1}._2nucn{color:#484848;font-size:14px;font-weight:400;line-height:1.43;padding-top:10px}.P652_{color:#008489}@media screen and (max-width:640px){._3Xd68{display:block;float:left;border-bottom:1px solid #dce0e0}._3Xd68:last-of-type{border-bottom:1px solid transparent}}", ""]);

// exports
exports.locals = {
	"root": "_1QFug",
	"container": "_1aTkE",
	"feedbackContainer": "_2ksEc",
	"feedbackRow": "rSBRL",
	"feedbackBox": "_3Xd68",
	"feedbackIcon": "XMBLN",
	"feedbackContent": "_1GBhB",
	"landingLabel": "_3Y6Jq",
	"landingCaption": "_2nucn",
	"modalCaptionLink": "P652_"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./~/postcss-loader?{"config":"./tools/postcss.config.js"}!./src/components/Feedback/Feedback.css
// module id = 2531
// module chunks = 15